var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {LockDeviceAsync as InvokeAsync , LockDeviceSync as InvokeSync}

async function LockDeviceAsync(LoginToken,DeviceUUID)
{
    var ResetTablePromise = new Promise((resolve, reject) => {
        LockDeviceSync(LoginToken,DeviceUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await ResetTablePromise;
}

function LockDeviceSync(LoginToken,DeviceUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/LockDevice',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            DeviceUUID:DeviceUUID ,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
